import React from 'react';
import styled from 'styled-components';
import {
    Button,
    Result as AntResult,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { NoInternetIcon } from '@assets';

const Result = styled(AntResult)`
height: 100vh;
overflow: hidden;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding: 0 !important;

.ant-result-title {
    font-size: 20px !important;
}

.ant-btn-primary {
    min-width: 170px;
}
`;

const NoInternet = () => {
    const { t } = useTranslation()

    return (
        <Result
            icon={<NoInternetIcon />}
            title={t("error.noInternetTitle")}
            subTitle={t("error.noInternetSubtitle")}
            extra={
                <Button
                    type="primary"
                    onClick={() => window.location.reload()}
                >
                    {t("error.retry")}
                </Button>
            }
        />
    );
}

export default NoInternet;